import Link from 'next/link'
import type { ReactNode } from 'react'

type StaticPageShellProps = {
  title: string
  description?: string
  children: ReactNode
  narrow?: boolean
}

export function StaticPageShell({
  title,
  description,
  children,
  narrow = false,
}: StaticPageShellProps) {
  return (
    <main
      className={`mx-auto w-full px-4 py-12 sm:px-6 lg:px-8 ${narrow ? 'max-w-3xl' : 'max-w-5xl'}`}
    >
      <header className="mb-10">
        <h1 className="text-3xl font-bold tracking-tight text-zinc-900 dark:text-zinc-100 sm:text-4xl">
          {title}
        </h1>
        {description ? (
          <p className="mt-3 max-w-2xl text-base text-zinc-600 dark:text-zinc-400">
            {description}
          </p>
        ) : null}
      </header>
      <div className="text-sm leading-relaxed text-zinc-700 dark:text-zinc-300">
        {children}
      </div>
    </main>
  )
}

export function StaticSection({
  title,
  children,
}: {
  title?: string
  children: ReactNode
}) {
  return (
    <section className="mb-8">
      {title ? (
        <h2 className="mb-3 text-lg font-semibold text-zinc-900 dark:text-zinc-100">
          {title}
        </h2>
      ) : null}
      {children}
    </section>
  )
}

export function StaticLinkList({
  items,
}: {
  items: { label: string; href: string }[]
}) {
  return (
    <ul className="space-y-2">
      {items.map((item) => (
        <li key={item.href + item.label}>
          <Link
            href={item.href}
            className="text-zinc-700 underline-offset-2 transition hover:text-zinc-950 hover:underline dark:text-zinc-300 dark:hover:text-white"
          >
            {item.label}
          </Link>
        </li>
      ))}
    </ul>
  )
}
